import {  Component, ElementRef, HostListener, ModuleWithProviders, ViewChild,OnInit } from '@angular/core';
import { SeoService } from '../seoService';
declare var $: any;

import { Http, Headers, Response, RequestOptions } from '@angular/http';

import { Router, NavigationEnd } from '@angular/router';

import { ApidataService } from '../apidata.service';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { environment, GINConstants } from '../../environments/environments';
@Component({
  selector: 'app-helpcenter',
  standalone: true,
  imports: [HeaderComponent, CommonModule, FormsModule, ReactiveFormsModule, HttpClientModule, FooterComponent],
  templateUrl: './helpcenter.component.html',
  styleUrl: './helpcenter.component.css',
  providers: [ApidataService],
})
export class HelpcenterComponent implements OnInit{
  checkLogin;
  public esubText: string = '';
  login;
  public color: string = 'black';
  public esubText2 : string = '';
  public logintext: string = '';
  public esubText3 : string = '';
  constructor(private router: Router,private seoService: SeoService,  private apirequest: ApidataService,) {

    this.checkLogin = this.apirequest.isLoggedIn();

    this.login=localStorage.getItem('id_token');
    this.login = localStorage.getItem('authentication_token')
  }

  public ngOnInit() {
    scrollTo(0,0);
    this.seoService.setTitle('Help Center');
   
  }

  public ngAfterViewInit(): void {
    let self = this;


    $(document).ready(function () {

      $('#row_faqs .btn').click(function () {
  
        if ($(this).hasClass('active')) {
 
          $(this).removeClass("active");
          $(this).parent().parent().removeClass("active");
        }
        else {
          $("#row_faqs .btn").removeClass("active");
          $("#row_faqs .card").removeClass("active");
          $(this).addClass("active");
          $(this).parent().parent().addClass("active");
        }
      });

      $('#homeText').focus();

      $('#homeText').keyup(function () {
        $('.text-field-placeholder').hide();
        $('#chkGramTxtLimit').hide();
        var text_length = $("#homeText").val().length;
        if (text_length <= 0) {
          $('.text-field-placeholder').show();
        }
      })
      $('.text-field-placeholder').click(function () {
        $('#homeText').focus();
      })

      $('#homeText').on('click', function () {
        $('.text-field-placeholder').hide();
        $('#chkGramTxtLimit').hide();
      })

      $(window).scroll(function () {
      

      $('#loginButton1').click(function () {

        $('#signupModal').modal('hide');
        $('#fpwdModal').modal('hide');
        $('#loginModal').modal('show');
      });

      $('#loginButton2').click(function () {
     
        $('#signupModal').modal('hide');
        $('#fpwdModal').modal('hide');
        $('#loginModal').modal('show');
      });

      $('#signupButton').click(function () {
        $('#loginModal').modal('hide');
        $('#fpwdModal').modal('hide');
        $('#signupModal').modal('show');
      });

      $('#fpButton').click(function () {
        $('#loginModal').modal('hide');
        $('#signupModal').modal('hide');
        $('#fpModal').modal('show');
      });

      $('.modal-backdrop').removeClass('modal-backdrop');

      $('#about-us').click(function () {
        $('html, body').animate({
          scrollTop: ($('#row_about').offset().top - 100)
        }, 700);
      });
      $('#why-grammar').click(function () {
        $('html, body').animate({
          scrollTop: ($('#row_use_gram h3').offset().top - 100)
        }, 700);
      });
      $('#why-plagiarism').click(function () {
        $('html, body').animate({
          scrollTop: ($('#row_use_plag h3').offset().top - 100)
        }, 700);
      });
      $('#tips').click(function () {
        $('html, body').animate({
          scrollTop: ($('#row_tips').offset().top - 50)
        }, 700);
      });
      $('#support').click(function () {
        $('html, body').animate({
          scrollTop: ($('#row_contact').offset().top - 50)
        }, 700);
      });

      $('#loginButton').click(function () {
        $('#signupModal').modal('hide');
        $('#loginModal').modal('show');
      })

      $('#plaagiarism-tab').click(function () {
        $('#grammar-tab').addClass('btlr_radius');
      })
      $('#grammar-tab').click(function () {
        $('.nav-link').removeClass('btlr_radius');
      })

      let giftofspeed = document.createElement('link');
      giftofspeed.rel = 'stylesheet';
      giftofspeed.href = 'https://fonts.googleapis.com/css?family=Quicksand:300,400,500,700';
      giftofspeed.type = 'text/css';
      let godefer = document.getElementsByTagName('link')[0];
      godefer.parentNode.insertBefore(giftofspeed, godefer);



    });
  })}
  public eFormSubmission() {
    let firstname = $('#form_name').val();
    let email = $('#form_email').val();
    let subject = $('#form_subject').val();
    let message = $('#form_message').val();
    let reference_no = $('#reference_no').val();
 
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

    if (firstname === '' && message === '' && email === '' && subject === '') {

      this.color = 'red';
      this.esubText = 'Please provide the required fields';
      $('#form_name').val('').css( "border-color", "red" );
      $('#form_message').val('').css( "border-color", "red" );
      $('#reference_no').val('').css( "border-color", "red" );
      $('#form_email').val('').css( "border-color", "red" );
      $('#form_subject').val('').css( "border-color", "red" );
      setTimeout(function() { $("#esubText").hide();

      }, 3000);


    } else if (email === '') {
      this.color = 'red';
      this.esubText = 'Please provide the Email';
      $('#form_email').val('').css( "border-color", "red" );
    }
     else if (reg.test(email) === false) {
      this.color = 'red';
      this.esubText = 'Please provide correct Email';
      $('#form_email').val('').css( "border-color", "red" );
    }
    else if (firstname != '' && message != '' &&  subject != '' && reg.test(email) === false) {
      this.color = 'red';
      this.esubText3 = 'Please provide correct Email';
      $('#form_email').val('').css( "border-color", "red" );
    }
    else if (firstname === '') {
      this.color = 'red';
      this.esubText = 'Please provide the required field ';
      $('#form_name').val('').css( "border-color", "red" );
    }else if (subject === '') {
      this.color = 'red';
      this.esubText = 'Please provide the required field';
      $('#form_subject').val('').css( "border-color", "red" );
    }else if (message === '') {
      this.color = 'red';
      this.esubText = 'Please provide the required field';
      $('#form_message').val('').css( "border-color", "red" );
    }  else {
      let data2 = JSON.stringify({ firstname: firstname, email: email, subject: subject, message: message, reference_no:reference_no });
      this.apirequest.postResources(data2, environment.API_URL+'/api/helpCentre').subscribe((data) => {
      
        let receivedData = data;
        receivedData['help_message']== 'Thank you for your feedback. We will get back to you soon';
        $('#form_email').val('').css( "border-color", "#e7e7ec" );
                $('#form_subject').val('').css( "border-color", "#e7e7ec" );
                $('#form_message').val('').css( "border-color", "#e7e7ec" );
                $('#form_name').val('').css( "border-color", "#e7e7ec" );
                $('#reference_no').val('').css( "border-color", "#e7e7ec" );
              this.color = 'green';
              this.esubText2 = 'Your query submitted successfully';
              this.esubText = '';
              this.esubText3 = '';
              $("#esubText2").show();
              setTimeout(function() { $("#esubText2").hide();

              }, 3000);

      },
        (error) => this.handleError(error)
      );
    }
  }

  public handleError(error: any) {
  
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    // console.error(errMsg); 
    this.color = 'red';
    this.logintext = "Invalid Email / Passowrd";

  }
     // SCROL
     shouldShowButton: boolean = false;
     @HostListener('window:scroll', [])
     onWindowScroll() {
       if (window.pageYOffset > 200) {
         this.shouldShowButton = true;
       } else {
         this.shouldShowButton = false;
       }
     }
     scrollToTop() {
       window.scrollTo({ top: 0, behavior: 'smooth' });
       this.router.navigate(['/help-center'])
     }
     //

}
